import { defineVideoTemplate } from "@assets/templates/builders";
import { BASE_ASSETS } from "@assets/templates/constants";

export const javelinVideoExample = defineVideoTemplate({
  slug: "javelin-video-example",
  title: "Javelin",
  description: "Visual reasoning",
  subdescription: "Reason about the throw with only what's on screen",
  poster: BASE_ASSETS.javelinVideoPoster,
  video: BASE_ASSETS.javelinVideo,
  prompt: "Who is throwing and how far do they throw? Use only visual queues. Do not use prior knowledge.",
  enableThinking: true,
});
